import { LoadingSpinner } from "@bluefalcon/components-package";
import { ReportConfig, ReportConfigCreateRequest, ReportConfigUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { Box, Button, Flex, Table, TableCaption, Tbody, Td, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { formatISOToFrontendDate } from "@bluefalcon/utils-package";
import { reportConfigService } from "../../services";
import { AddEditReportConfigModal } from "../../modals/add-edit-report-config.modal";

type ReportConfigsTableProps = {};

export const ReportConfigsTable = ({ }: ReportConfigsTableProps) => {

    const [reportConfigs, setReportConfigs] = useState<ReportConfig[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { isOpen, onClose, onOpen } = useDisclosure();
    const [selectedTicket, setSelectedTicket] = useState<ReportConfig>();

    const fetchReportConfigs = async () => {
        setIsLoading(true);
        const { results, total: _total } = await reportConfigService.searchReportConfigs({});
        setReportConfigs(orderByCreatedDate(results));
        setTotal(_total);
        setIsLoading(false);
    };

    const orderByCreatedDate = (data: ReportConfig[]) => {
        return data.sort((a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime());
    };

    const handleCreate = async (data: ReportConfigCreateRequest) => {
        await reportConfigService.createReportConfig(data);
        await fetchReportConfigs();
    };

    const handleEdit = async (id: number, data: ReportConfigUpdateRequest) => {
        await reportConfigService.updateReportConfigById(id, data);
        await fetchReportConfigs();
    };

    const handleDelete = async (id: number) => {
        await reportConfigService.deleteReportConfigById(id);
        await fetchReportConfigs();
    };

    const handleClickEdit = (reportConfig: ReportConfig) => {
        setSelectedTicket(reportConfig);
        onOpen();
    };

    const handleAddButtonClick = () => {
        setSelectedTicket(undefined);
        onOpen();
    };

    useEffect(() => {
        fetchReportConfigs();
    }, []);

    if (isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>
            <Flex>
                <Button onClick={handleAddButtonClick} ml={'auto'} colorScheme="teal">Add Report Config</Button>
            </Flex>
            <Table variant="simple">
                <TableCaption textAlign={'left'}>Total Tickets: {total}</TableCaption>
                <Thead>
                    <Tr>
                        <Th>ID</Th>
                        <Th>Details</Th>
                        <Th>Created Date</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {(!isLoading && reportConfigs.length > 0) ? reportConfigs.map((reportConfig) => (
                        <Tr key={reportConfig.id}>
                            <Td>{reportConfig.id}</Td>
                            <Td>{reportConfig.name}</Td>
                            <Td>{formatISOToFrontendDate(reportConfig.createdDate) ?? ''}</Td>
                            <Td>
                                <Button size="sm" onClick={() => handleClickEdit(reportConfig)}>
                                    Edit
                                </Button>
                            </Td>
                        </Tr>
                    )) : <Box textAlign={'center'} mt={4}>
                        No Reports.
                    </Box>}
                </Tbody>
            </Table>
            <AddEditReportConfigModal
                isOpen={isOpen}
                onClose={onClose}
                handleAddReportConfig={handleCreate}
                handleEditReportConfig={handleEdit}
                handleDeleteReportConfig={handleDelete}
                reportConfig={selectedTicket}
            />
        </>
    )
};
